import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import '../styles/global.css';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import padrao from '../assets/profile.png'

function ValidarMembro() {
    const { codigo } = useParams();
    const [dadosMembro, setDadosMembro] = useState(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    
    const customFormatSmallDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens

    useEffect(() => {
        setIsLoading(true);
        if (codigo) {
            var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
            const dados = {
                IdPessoa: 0,
                pesEmail: '',
                associado: '99',
                pesCodigoGUID: codigo
            };
            axios
            .post(
                process.env.REACT_APP_API_URL + '/routes.php?metodo=obtemCadastroAssociado',
                dados,
                {
                    headers: {
                        "X-Access-Token": token,
                        "Content-Type": "application/json; charset=utf-8"
                    }
                }
            )
            .then(response => {
                setDadosMembro(response.data);
                //se o primeiro caracter em response.data.pesCelular for = 0 retira e mantem o restante
                if(response.data.pesCelular !== null 
                    && response.data.pesCelular !== undefined 
                    && response.data.pesCelular !== '' 
                    && response.data.pesCelular){
                    if (response.data.pesCelular.charAt(0) === '0'){
                        response.data.pesCelular = response.data.pesCelular.substring(1);
                    }
                    response.data.pesCelular = response.data.pesCelular;
                    response.data.pesCelular = response.data.pesCelular
                        .replace('(', '')
                        .replace(')', '')
                        .replace('-', '')
                        .replace(' ', '')
                        .replace('+', '');

                    response.data.pesCelular = "+550" + response.data.pesCelular;
                }
                setTelefoneMembro(response.data.pesCelular !== null 
                    && response.data.pesCelular !== undefined 
                    && response.data.pesCelular !== '' ? 
                    response.data.pesCelular : '');
            })
            .catch(error => {
                console.error('Erro ao validar membro:', error);
            });
        }
        setIsLoading(false);
    }, [codigo]);

    //salvar log de navegação
  useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página de Validar Membro: " + (codigo ? codigo : ""),
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);

    const telefoneEmergencia = '+55011982921591';
    const mensagemEmergencia = encodeURIComponent('Olá! Tenho informações importantes sobre um membro do Brasil Extremos.');
    const linkWhatsAppEmergencia = `https://wa.me/${telefoneEmergencia}?text=${mensagemEmergencia}`;

    const [telefoneMembro, setTelefoneMembro] = useState('');
    const mensagemMembro = encodeURIComponent('Olá! Tenho informações importantes sobre uma identificação de membro encontrada.');
    const linkWhatsAppMembro = `https://wa.me/${telefoneMembro}?text=${mensagemMembro}`;

    return (
        <div style={{ paddingBottom: '80px'}}>
            <main>
                <div>
                    <div className='headerMain'>
                        <label className='labelTitulo' >VALIDAR AUTENTICIDADE</label>
                        <h3>DADOS BÁSICOS DO MEMBRO</h3>
                    </div>
                    <div className='tabelaPadrao'>
                        {isLoading ? (
                            <div style={{ width: "100%", textAlign: "center"}}>
                                <CircularProgress />
                            </div>
                        ) : (
                            <>
                            {dadosMembro && Object.keys(dadosMembro).length > 0 ? (
                                <div className="p2" style={{ cursor: 'pointer', borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '10px' }}>
                                    <p>
                                        {/* {image ? (
                                            <img
                                            src={URL.createObjectURL(image)}
                                            alt="Logo2"
                                            className="imgProfile"
                                            width="150"
                                            height="150"
                                            />
                                        ) : ( */}
                                            <img
                                            src={dadosMembro.pesFoto !== null && dadosMembro.pesFoto !== '' ? process.env.REACT_APP_API_URL + "/" + dadosMembro.pesFoto : padrao} 
                                            alt="" 
                                            resizemode="contain"
                                            className="imgProfile" />
                                        {/* )} */}
                                    </p>
                                    <p style={{ color: '#000', marginTop: '10px' }} className="fs16"><strong>{dadosMembro.pesNome}</strong></p>
                                    <p style={{ color: '#000', marginTop: '10px' }}><strong><span style={{ color: '#666363' }}>Código: <br/></span> MGBE-{dadosMembro.IdPessoa < 10 ? `000${dadosMembro.IdPessoa}` : dadosMembro.IdPessoa < 100 ? `00${dadosMembro.IdPessoa}` : dadosMembro.IdPessoa < 1000 ? `0${dadosMembro.IdPessoa}` : dadosMembro.IdPessoa}</strong></p>
                                    <p style={{ color: '#000', marginTop: '10px' }}><strong><span style={{ color: '#666363' }}>Nome de Estrada: <br /></span>{dadosMembro.pesApelido}</strong></p>
                                    <p style={{ color: '#000', marginTop: '10px' }}><strong><span style={{ color: '#666363' }}>Contato de Emergência: <br /></span>{dadosMembro.pesEmergencia}</strong></p>
                                    <p style={{ color: '#000', marginTop: '10px' }}><strong><span style={{ color: '#666363' }}>Telefone: <br /></span>{dadosMembro.pesTelefone}</strong></p>
                                    <p style={{ color: '#000', marginTop: '10px' }}><strong><span style={{ color: '#666363' }}>Celular: <br /></span>{dadosMembro.pesCelular}</strong></p>
                                    <p style={{ color: '#000', marginTop: '10px' }}><strong><span style={{ color: '#666363' }}>Data de Nascimento: <br /></span>{dadosMembro.pesNascimento} <span style={{ color: '#666363' }}>Idade: </span>{now.getFullYear() - new Date(dadosMembro.pesNascimento).getFullYear()} Anos</strong></p>
                                    <p style={{ color: '#000', marginTop: '10px' }}><strong><span style={{ color: '#666363' }}>Endereço: <br /></span>{dadosMembro.pesEndereco} <br /> <span style={{ color: '#666363' }}>Bairro: <br /></span>{dadosMembro.pesBairro} <br /> <span style={{ color: '#666363' }}>Cidade: <br /></span>{dadosMembro.pesCidade} <br /> <span style={{ color: '#666363' }}>Estado: <br /></span>{dadosMembro.pesEstado} <br /> <span style={{ color: '#666363' }}>CEP: <br /></span>{dadosMembro.pesCEP} </strong></p>
                                    <p style={{ color: '#000', marginTop: '10px' }}><strong><span style={{ color: '#666363' }}>Data de Validação: <br /></span>{customFormatDate}</strong></p>
                                </div>
                            ) : (
                                <p>Membro não encontrado.</p>
                            )}
                            <div className="p2" style={{ textAlign: 'center', cursor: 'pointer', borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '10px' }}>
                                <p style={{ color: '#ca1313', marginTop: '10px' }}><strong>EM CASO DE EMERGÊNCIA: CONTATAR A GESTÃO.</strong></p>
                                <a href={linkWhatsAppEmergencia} target="_blank" rel="noopener noreferrer" className="buttonModalPadrao p1 mt1" style={{ textDecoration: 'none', display: 'inline-block' }}>
                                    Contato de Emergência {<WhatsApp style={{ marginLeft: '0.4em', height: '1em', marginBottom: '-5px' }} />}
                                </a>
                            </div>
                            {dadosMembro && dadosMembro.pesCelular !== null && dadosMembro.pesCelular !== undefined && dadosMembro.pesCelular !== '' ? (
                            <div className="p2" style={{ textAlign: 'center', cursor: 'pointer', borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '10px'}}>
                                <p style={{ color: '#ca8413', marginTop: '10px' }}><strong>CASO TENHA ENCONTRADO A IDENTIFICAÇÃO: CONTATAR O MEMBRO.</strong></p>
                                <a href={linkWhatsAppMembro} target="_blank" rel="noopener noreferrer" className="buttonModalPadrao p1 mt1" style={{ textDecoration: 'none', display: 'inline-block' }}>
                                    Contatar Membro {<WhatsApp style={{ marginLeft: '0.4em', height: '1em', marginBottom: '-5px' }} />}
                                </a> 
                            </div>
                             ) : ''
                            }
                            </>
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
}

export default ValidarMembro;